module.exports = __webpack_public_path__ + "static/fonts/notokr-bold.073dba1.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/views/sales/dashboard/assest/font/notosanskr/notokr-bold.woff2
// module id = 6Xvs
// module chunks = 0